import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { TEAM_TYPES } from 'common/constants/constants';
import { selectTeamId } from 'state/actions';
import {
  toggleSnackBar,
  createTeam,
  updateTeam,
  updateTeamContributors,
  getTeams,
  createGroup,
  updateGroup,
  getProjects
} from 'state/callers';
import {
  getOnEditTeam,
  onCreateTeam,
  onCreateGroup,
  getOnEditGroup
} from '../../../../people/views/teams/teams.service';
import useTeams from './useTeams';

const useTeamsConfig = () => {
  const location = useLocation();
  const isSelectTeamId = location?.state?.isSelectTeamId;

  const dispatch = useDispatch();
  const { goBack } = useTeams();

  const onSubmit = ({
    initialTeamProps,
    teamFormValues,
    contributorsToAdd,
    contributorsToRemove,
    isEdit,
    isSynced
  }) => {
    const { type } = teamFormValues;
    if (type === TEAM_TYPES.TEAM || isSynced) {
      isEdit
        ? getOnEditTeam({
            updateTeam: team => dispatch(updateTeam(team)),
            selectedTeam: initialTeamProps,
            updateTeamContributors: (...args) =>
              dispatch(updateTeamContributors(...args)),
            getTeams: () => dispatch(getTeams()),
            toggleModal: () => goBack(),
            toggleSnackBar: params => dispatch(toggleSnackBar(params))
          })({
            ...teamFormValues,
            contributorsToAdd,
            contributorsToRemove
          })
        : onCreateTeam({
            createTeam: team => dispatch(createTeam(team)),
            toggleModal: () => goBack(),
            toggleSnackBar: params => dispatch(toggleSnackBar(params)),
            getTeams: () => {
              dispatch(getTeams());
              dispatch(getProjects());
            },
            ...(isSelectTeamId
              ? {
                  selectTeamId: teamId => dispatch(selectTeamId(teamId))
                }
              : {})
          })(teamFormValues);
    } else {
      const isGroup = true;

      isEdit
        ? getOnEditGroup({
            updateGroup: team => dispatch(updateGroup(team)),
            selectedTeam: initialTeamProps,
            updateGroupContributors: (...args) =>
              dispatch(updateTeamContributors(...args, isGroup)),
            getTeams: () => dispatch(getTeams()),
            toggleModal: () => goBack(),
            toggleSnackBar: params => dispatch(toggleSnackBar(params))
          })({
            ...teamFormValues,
            contributorsToAdd,
            contributorsToRemove
          })
        : onCreateGroup({
            createGroup: team => dispatch(createGroup(team)),
            toggleSnackBar: params => dispatch(toggleSnackBar(params)),
            toggleModal: () => goBack(),
            getTeams: () => dispatch(getTeams())
          })(teamFormValues);
    }
  };

  return {
    onSubmit
  };
};

export default useTeamsConfig;
